import { createSelector } from '@ngrx/store';

import { routerState } from '../root';

export const getCurrentRoute = createSelector(routerState, (router) => router?.current);
